export enum WizardStepComponentType {
    Service = 'service-select',
    Data = 'form-data',
    Fields = 'maps',
    Summary = 'summary',
};
